import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export const UserPrivateRoute = ({ component: Component, ...rest }) => {

  const userData = JSON.parse(localStorage.getItem("access_token"));
 
  return userData && userData.token && userData.role==='USER' ? <Outlet /> : <Navigate to="/login" />;
}

export const AdminPrivateRoute1 = ({ component: Component, ...rest }) => {
  const userData = JSON.parse(localStorage.getItem("access_token"));
  return userData && userData.token && userData.role==='ADMIN1'? <Outlet /> : <Navigate to="/login" />;
};


export const AdminPrivateRoute2 = ({ component: Component, ...rest }) => {
  const userData = JSON.parse(localStorage.getItem("access_token"));
  return userData && userData.token && userData.role==='ADMIN2' ? <Outlet /> : <Navigate to="/login" />;
};


export const AdminPrivateRoute3 = ({ component: Component, ...rest }) => {
  const userData = JSON.parse(localStorage.getItem("access_token"));
  return userData && userData.token && userData.role==='ADMIN3' ? <Outlet /> : <Navigate to="/login" />;
};
